import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable, of } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  startWith,
  switchMap,
} from "rxjs/operators";
import { TreeViewEntity } from "../../models/tree-view-entity.model";
import { TreeViewTemplateDirective } from "./treeview-template.direcive";
export interface IDataProvider {
  getKey: (object) => number | string;
  getDisplayName: (object) => string;
  loadData: (search: string) => Observable<Array<TreeViewEntity>>;
}

@Component({
  selector: "app-treeview",
  templateUrl: "./treeview.component.html",
  styleUrls: ["./treeview.component.scss"],
})
export class TreeViewComponent implements OnInit {
  @Input() dataProvider: IDataProvider;
  @Input() searchable: boolean;
  @Input() scrollHeight: string = "auto";
  @Output() onSelect: EventEmitter<TreeViewEntity> = new EventEmitter();
  @ContentChild(TreeViewTemplateDirective, { read: TemplateRef }) template: TemplateRef<any>;

  items: Array<TreeViewEntity>;
  searchControl = new FormControl(null);
  selectedItem: TreeViewEntity;

  select(item: TreeViewEntity) {
    this.selectedItem = item;
    this.onSelect.emit(item);
  }

  ngOnInit() {
    this.searchControl.valueChanges
      .pipe(
        startWith(null),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((search: string) => {
          return this.search(search);
        })
      )
      .subscribe((items) => {
        this.items = items;
      });
  }

  search(search: string): Observable<TreeViewEntity[]> {
    return this.dataProvider.loadData(search).pipe(
      catchError((err) => {
        return of([]);
      })
    );
  }
}
